import React from 'react'
import PropTypes from 'prop-types'

const BoatIcon = ({ customClassName, width, height, fill, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Boat"
    viewBox="0 0 511.998 511.998"
  >
    <title id="boat-icon">Boat</title>
    <g>
      <path
        fill={fill}
        d="M482.193,315.609L19.174,263.436c-3.558-0.401-5.956,3.456-4.113,6.528c29.594,49.365,99.652,84.164,181.205,84.164
  			h276.216c1.877,0,3.524-1.22,4.079-3.012l9.233-30.012C486.579,318.553,484.847,315.908,482.193,315.609z"
      />
    </g>
    <g>
      <path
        fill={fill}
        d="M510.652,230.062c-1.357-2.116-3.567-3.524-6.05-3.857l-128-17.067c-4.617-0.606-8.96,2.662-9.591,7.33
  			c-0.631,4.668,2.662,8.969,7.33,9.591l14.49,1.929c2.116,0.282,3.703,2.091,3.703,4.224v13.193c0,2.534-2.202,4.514-4.719,4.241
  			l-34.133-3.661c-2.167-0.222-3.814-2.057-3.814-4.233v-37.35c0-0.845,0.247-1.664,0.717-2.364l14.916-22.374
  			c1.707-2.56,1.903-5.837,0.521-8.576c-1.391-2.748-4.147-4.54-7.219-4.685l-179.2-8.533c-2.876-0.026-5.666,1.212-7.347,3.567
  			c0,0-34.099,47.923-41.574,58.47c-0.896,1.263-2.398,1.937-3.934,1.766L9.438,209.113c-2.423-0.256-4.813,0.521-6.613,2.133
  			C1.033,212.868,0,215.172,0,217.595c0,8.218,1.067,16.273,3.081,24.09c0.444,1.724,1.946,2.978,3.712,3.183L488.9,299.191
  			c2.039,0.23,3.951-1.024,4.557-2.987l18.168-59.034C512.358,234.773,512,232.17,510.652,230.062z M246.255,182.796l-6.656,46.609
  			c-0.324,2.261-2.33,3.874-4.608,3.644c-16.648-1.681-79.198-8.26-79.198-8.26c-3.243-0.35-4.915-4.062-3.021-6.724l29.312-41.037
  			c0.845-1.178,2.227-1.852,3.678-1.783l56.474,2.688C244.745,178.052,246.613,180.304,246.255,182.796z M338.765,189.017
  			l-5.248,7.851c-0.469,0.7-0.717,1.527-0.717,2.372v39.774c0,2.534-2.202,4.514-4.719,4.241l-67.721-7.253
  			c-2.398-0.256-4.113-2.458-3.772-4.847l6.903-48.324c0.307-2.176,2.227-3.763,4.429-3.661l67.499,3.217
  			C338.731,182.54,340.608,186.252,338.765,189.017z M443.733,250.892c0,2.534-2.202,4.514-4.719,4.241
  			c0,0-17.715-1.997-25.651-2.935c-2.15-0.247-3.763-2.074-3.763-4.233v-12.339c0-2.577,2.27-4.574,4.83-4.233l25.6,3.413
  			c2.116,0.29,3.703,2.099,3.703,4.233V250.892z M490.863,246.608l-3.166,10.274c-0.597,1.946-2.5,3.2-4.531,2.987l-18.56-1.988
  			c-2.159-0.23-3.806-2.065-3.806-4.241v-11.179c0-2.577,2.27-4.574,4.83-4.233l21.717,2.893
  			C489.958,241.471,491.639,244.083,490.863,246.608z"
      />
    </g>
  </svg>)

BoatIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  customClassName: PropTypes.string,
}

BoatIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'blue',
  customClassName: '',
}

export default BoatIcon



// WEBPACK FOOTER //
// ./src/components/icons/Boat.js